import { auth } from '@/utils/auth';
import { AUTHENTICATE_PATH } from '@/api/auth';
import { logoutEvent } from '@/pages/YouChat/utils.ts';
import { apiRequest } from './apiRequestInit';
import {
  ApiError,
  ApiResponse,
  TRequestConfig,
  TRequestMethod,
  TRequestParams,
  isRequestMethod
} from '@gry-dmitrij/api-request';

let pause: null | Promise<void> = null

const reauth = async() => {
  const promise: {
    resolve?: (value: (void | PromiseLike<void>)) => void
    reject?: (reason?: any) => void
  } = {}
  pause = new Promise((resolve, reject) => {
    promise.resolve = resolve
    promise.reject = reject
  })
  try {
    await auth()
    promise.resolve?.()
  } catch (err) {
    return promise.reject?.(err)
  } finally {
    pause = null
  }
}

const request = async <T = any>(
  method: TRequestMethod,
  url: string,
  params?: TRequestParams,
  config?: TRequestConfig
): Promise<ApiResponse<T>> => {
  if (!method) {
    throw new Error('Method is wrong')
  }

  if (!(isRequestMethod(method))) {
    throw new Error('Method is wrong')
  }

  if (pause && url !== AUTHENTICATE_PATH) {
    await pause
  }

  const promise = apiRequest.request(method, url, params, config)

  return promise.catch(async(err: ApiError) => {
    if (err.status === 406) {
      if (pause) {
        return request(method, url, params, config)
      }
      try {
        await reauth();
        return apiRequest.request(method, url, params, config)
      } catch (err) {
        return Promise.reject(err)
      }
    }
    if (err.status === 401 || err.status === 422) {
      logoutEvent()
    }
    return Promise.reject(err)
  })
}

export default request
